import * as ActionTypes from '~/actions/ActionTypes'
import { MEDIA_TYPE, SOURCE_FILE_TYPES, FILE_TYPE } from '~/enums'
import { setSourceFilesParamsNoReload, updateFileRefCount } from './sourceFiles'
import * as API from '~/ServerAPI'
import { renameFolder as renameFolderApi, createFolder as createFolderApi } from '~/services/FoldersApiService'
import { parseLoadedFile } from '~/Util/sourceFile'
import * as Selectors from '~/selectors'
import { selectMenuItem } from '~/selectors/mainView'

export const openMediaDirectory = (type, directory, { fromRoot = false } = {}) => dispatch => {
  dispatch(setSourceFilesParamsNoReload(type, { search: '' }))
  dispatch({
    type: ActionTypes.ACTIONS_MEDIA_DIRECTORY_OPEN,
    payload: { type, directory, fromRoot },
  })
}

export const openFolderById = (type, id, options = {}) => async (dispatch, getState) => {
  const currentFolderId = Selectors.selectCurrentFolderId(getState(), type)
  if (id && id !== currentFolderId) {
    const { data } = await API.getMediaFile(id, FILE_TYPE.FOLDER)
    const directory = parseLoadedFile(SOURCE_FILE_TYPES.MEDIA, data)
    await dispatch(openMediaDirectory(type, directory, options))
  }
}

export const mediaDirectoryMoveForward = type => dispatch => {
  dispatch(setSourceFilesParamsNoReload(type, { search: '' }))
  dispatch({
    type: ActionTypes.ACTIONS_MEDIA_DIRECTORY_FORWARD,
    payload: { type },
  })
}

export const mediaDirectoryMoveBackward = type => dispatch => {
  dispatch(setSourceFilesParamsNoReload(type, { search: '' }))
  dispatch({
    type: ActionTypes.ACTIONS_MEDIA_DIRECTORY_BACKWARD,
    payload: { type },
  })
}

/**
 *
 * @param {string} sourceFilesType
 * @param {string} name
 * @param {string|number} parentFolderId
 * @returns
 */
export const createFolder = (
  sourceFilesType, name, parentFolderId
) => async (dispatch, getState) => {
  try {
    const menuItem = selectMenuItem(getState())
    const mediaPool = menuItem === SOURCE_FILE_TYPES.PROJECT_MEDIA
      ? menuItem
      : sourceFilesType
    const response = await createFolderApi({ name, folder: parentFolderId })
    const { id } = response
    await dispatch({ type: ActionTypes.MEDIA_FOLDER_CREATE,
      payload: {
        type: mediaPool,
        folder: parseLoadedFile(SOURCE_FILE_TYPES.MEDIA, {
          filetype: MEDIA_TYPE.FOLDER,
          name,
          id,
          isNew: true,
        }),
      } })
    await dispatch(updateFileRefCount(id, undefined, mediaPool, 1))
  } catch (e) {
    console.error('Cannot create folder:', e.message)
  }
}

export const renameFolder = (type, folderId, name) => async (dispatch, getState) => {
  try {
    const menuItem = selectMenuItem(getState())
    const mediaPool = menuItem === SOURCE_FILE_TYPES.PROJECT_MEDIA
      ? menuItem
      : type
    await renameFolderApi(folderId, name)
    await dispatch({ type: ActionTypes.MEDIA_FOLDER_RENAME,
      payload: {
        type: mediaPool,
        folderId,
        name,
      } })
  } catch (e) {
    console.error('Cannot rename folder:', e.message)
  }
}
